import React, { useState,useRef,useEffect }  from 'react';
import { Popconfirm, message, Button,Switch } from 'antd';
import { EditOutlined,DeleteOutlined,PlusOutlined } from '@ant-design/icons';
import { ProTable } from '@ant-design/pro-components';
import EditModel from './components/edit';
import {api_tenant_list, api_user_list, api_user_del, api_role_list, api_user_edit_status} from '../../api';
import routes from '../../menuRoute/index';
// import JSZip from 'jszip';
// import { saveAs } from 'file-saver';

export const waitTimePromise = async (time) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, time);
  });
};

export const waitTime = async (time) => {
  await waitTimePromise(time);
};

export default () => {
  const actionRef = useRef();

  const [showModal, setShowModal] = useState(false);
  const [rowInfo, setRowInfo] = useState({});
  const [pagination, setPagination] = useState({current:1,pageSize:10,total:0});
  const [pageSize, setPageSize] = useState(10);
  /*** @zh-CN 所有页面列表 *  */
  const [treeMenus, setTreeMenus] = useState([]);
  /*** @zh-CN 已选中列表 *  */
  const [tenantList, setTenantList] = useState([]);
  const [roleList, setRoleList] = useState([]);

  useEffect(() => {
    if (routes) {
      let menus= getTreeNodes(routes);
      console.log(menus);
      setTreeMenus(menus);
    }
    getTenantslist();
    getRolelist();
  }, []);
  
  const closeModal = () =>{
    setShowModal(false);
  }

  const getTreeNodes = (list) => {
    console.log(list)
    let arr = [];
    list.forEach((item)=>{
      if(item.path != '/tenant'){
        // if(item.name && (!item.hideInMenu)){
        if(item.title){
            if(item.children){
              let child=[]
                arr.push({title:item.title,key:item.path,children:getTreeNodes(item.children)})
            }else{
                arr.push({title:item.title,key:item.path})
            }
        }else{
            if(item.children){
                getTreeNodes(item.children)
            }
        }
      }
    });
    return arr
    // if(arr.length !== 0) setTreeData(arr);
 }

 
  // 获取租户列表
  const getTenantslist = async ()=>{
    try {
      await api_tenant_list({}).then((res) => {
        console.log('api_tenant_list-res-----------------', res);
        // var flag = checkLogin('A', res.data)
        if (res.data.code == 9) {
          var list = [{value:'', label:"--请选择--"}];
          for(let item of res.data.list){
            list.push({value:item.tenant_id, label:item.tenant_name, disabled:item.status=='1'?false:true});
          }
          console.log('list ------- ',list)
          setTenantList(list);
        }else
          message.error(res.data.msg);
      });
    } catch (error) {
      console.log('catch-error------------', error)
      // return false;
    }

  }
 
  // 获取角色列表
  const getRolelist = async ()=>{
    try {
      await api_role_list({}).then((res) => {
        console.log('api_role_list-res-----------------', res);
        // var flag = checkLogin('A', res.data)
        if (res.data.code == 9) {
          var list = [{value:'', label:"--请选择--"}];
          for(let item of res.data.list){
            list.push(item);
          }
          console.log('list ------- ',list)
          setRoleList(list);

        }else
          message.error(res.data.msg);
      });
    } catch (error) {
      console.log('catch-error------------', error)
      // return false;
    }

  }


  const columns = [
    {
      title: '用户ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
      search: false,
    },
    {
      title: '邮箱',
      dataIndex: 'email',
      key: 'email',
      // width: 80,
      // search: false,
    },
    {
      title: '手机',
      dataIndex: 'phone',
      key: 'phone',
      width: 120,
      // search: false,
    },
    // {
    //   title: '用户名称',
    //   dataIndex: 'username',
    //   key: 'username',
    //   ellipsis:true,
    //   // width: 100,
    // },
    {
      title: '所属租户',
      dataIndex: 'tenant_name',
      key: 'tenant_name',
      ellipsis:true,
      // width: 150,
      search: false,
    },
    {
      title:'添加时间',
      dataIndex: 'creat_time',
      key: 'creat_time',
      // valueType: "dateRange",
      width: 150,
      key:"creat_time",
      search: false,
    },
    {
      title: '添加用户',
      dataIndex: 'creat_username',
      key: 'creat_username',
      ellipsis:true,
      // width: 150,
      search: false,
    },
    {
      title: '状态',
      dataIndex: 'status',
      search:false,
      key:"status",
      width: 100,
      render: (_,record) => {
        return <Switch checkedChildren="激活" unCheckedChildren="停用" 
                  checked={record.status=='1'?true:false} 
                  disabled={record.name=='admin'?true:false}
                  onChange={(checked)=>{onChangeStatus(record.id, checked)}} />
      }
    },
    {
      title: '操作',
      valueType: 'option',
      width: 60,
      key: 'option',
      render: (text, record, _, action) => [
        record.roleid!=99 && 
        <a  key={"edita"+record.tenant_id}
          onClick={async() => {
            console.log('record ------------- ', record)
            console.log('action ------------- ', action)
            // action?.startEditable?.(record.id);
            setRowInfo(record);
            await waitTime(100);
            setShowModal(true);
          }}
        >
          <EditOutlined  key={"edit"+record.tenant_id}
            style={{backgroundColor:"rgb(24,188,156)",padding:"2px 3px",borderRadius:3,color:"white"}} />
        </a>,
        // record.roleid!=99 && 
        // <Popconfirm  key={"delpop"+record.tenant_id}
        //   title={"确定删除 "+record.username+" 吗?"} onConfirm={() => {delUser(record)}}>
        //   <DeleteOutlined  key={"del"+record.tenant_id}
        //     style={{backgroundColor:"#ff4d4f",padding:"2px 3px",borderRadius:3,color:"white"}} />
        // </Popconfirm>
      // <a href={record.url} target="_blank" rel="noopener noreferrer" key="view">
        //   查看
        // </a>,
        // <TableDropdown
        //   key="actionGroup"
        //   onSelect={() => action?.reload()}
        //   menus={[
        //     { key: 'copy', name: '复制' },
        //     { key: 'delete', name: '删除' },
        //   ]}
        // />,
      ],
    },
  ];

  const delUser = (record) =>{
    try {
      api_user_del({userid:record.id, username:record.username, tenant_id:record.tenant_id}).then((res) => {
        console.log('api_user_del-res-----------------', res);
        // var flag = checkLogin('A', res.data)
        if (res.data.code == 9) {
          message.success("操作成功");
          actionRef.current?.reload();
        }
        else
          message.error(res.data.msg);
      });
    } catch (error) {
      
      // return false;
    }
  }

  const onChangeStatus = (userid,checked) =>{
    console.log(userid, checked)
    try {
      api_user_edit_status({userid:userid, status:checked?"1":"0"}).then((res) => {
        console.log('api_user_edit_status-res-----------------', res);
        if (res.data.code == 9) {
          message.success("操作成功");
          actionRef.current?.reload();
        }
        else
          message.error(res.data.msg);
      });
    } catch (error) {
      
      // return false;
    }
  }

   
  return (
    <div>
          
    <ProTable
      headerTitle="用户列表"
      columns={columns}
      actionRef={actionRef}
      rowKey="id"
      cardBordered
      defaultSize="small"
      request={async (params, sort, filter) => {
        console.log(params,sort, filter);
        // await waitTime(2000);
        var tableData = [];
        var res = await api_user_list(params);
        console.log('api_user_list-res-----------------', res);
        if(res.data.code == 9){
          tableData = res.data.list;
        }else
          message.error(res.data.msg);

        return {
          data: tableData,
          // current: res.data.pageNo,
          // pageSize: res.data.pageSize,
          success: true,
          // total: res.data.totalRows,
        };
      }}
      search={{
        labelWidth: 'auto',
      }}
      options={{
        reload: false, // 去掉刷新按钮
        density: false, // 去掉密度按钮
        setting: true, // 保留列设置按钮
        setting: {
          listsHeight: 400,
        },
      }}
      style={{lineHeight: '0.40rem',marginTop:'0.32rem',overflowX: 'scroll',overflowY: 'scroll'}}  
      scroll={{x:700}}
      columnsState={{
        persistenceKey: 'pro-table-user',
        persistenceType: 'localStorage',
        onChange(value) {
          console.log('value: ', value);
        },
      }}

      // form={{
      //   // 由于配置了 transform，提交的参与与定义的不同这里需要转化一下
      //   syncToUrl: (values, type) => {
      //     if (type === 'get') {
      //       return {
      //         ...values,
      //         created_at: [values.startTime, values.endTime],
      //       };
      //     }
      //     return values;
      //   },
      // }}
      pagination={{
        pageSize: pageSize,
        showSizeChanger: true,
        onChange: (page,pagesize) => {
          console.log(page);
          console.log(pagesize);
          setPageSize(pagesize);
        },
      }}
      // dateFormatter="string"

      toolBarRender={() => [
        <Button
          key="button"
          icon={<PlusOutlined />}
          // style={{backgroundColor:"rgb(5,168,137)"}}
          onClick={async() => {
            setRowInfo({});
            await waitTime(100);
            setShowModal(true);
          }}
          type="primary"
        >
          新增用户
        </Button>,
      ]}
    />

    <EditModel
      showModal={showModal}
      closeModal={closeModal}
      rowInfo={rowInfo}
      refreshlist={()=>{actionRef.current?.reload();}}
      treeMenus={treeMenus}
      tenantList={tenantList}
      roleList={roleList}
  />

    </div>
  );
};